import { Suspense } from "react";
import { lazyWhenVisible } from "@/lib/lazy-visible";
import { Reveal } from "./Reveal";
import TestimonialsCarouselStatic from "./TestimonialsCarousel";

// No servidor o carrossel é renderizado completo (todos os depoimentos no HTML);
// no navegador o JavaScript dele (Embla) só carrega quando a seção se aproxima.
const Carousel = import.meta.env.SSR
  ? TestimonialsCarouselStatic
  : lazyWhenVisible("prova", () => import("./TestimonialsCarousel"));

export function SocialProofSection() {
  return (
    <section id="prova" className="relative bg-charcoal py-12 md:py-16">
      <div className="absolute inset-x-0 top-0 gold-divider" />
      <div className="absolute inset-x-0 bottom-0 gold-divider" />
      <div className="container-narrow">
        <Reveal y={20} duration={0.6} className="mx-auto max-w-3xl text-center">
          <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.32em] text-gold">
            Prova
          </p>
          <h2 className="text-balance text-3xl leading-tight text-ivory md:text-5xl">
             O que diz quem passou pelo processo.
          </h2>
        </Reveal>

        <Suspense fallback={null}>
          <Carousel />
        </Suspense>
      </div>
    </section>
  );
}
